import './ContainerWraper.css'

const ContainerWraper = (props) => {
    return (
        <div className={`ContainerWraper ${props.class}`}>
            {props.children}
        </div>
    )
}

export default ContainerWraper